import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { connect } from 'react-redux';
import { withStyles } from 'tss-react/mui';

import { closeDialog } from '../../actions/dialog';

const mapStateToProps = ({
  dialog: {
    contentProps: {
      callback
    },
  },
}) => ({
  callback
});

const mapDispatchToProps = {
  closeDialog
};

const mergeProps = (state, dispatchers, ownProps) => ({
  ...state,
  ...dispatchers,
  ...ownProps,
  callback: () => {
    state.callback(dispatchers.closeDialog);
  }
});

const styles = {
  container: {
    textAlign: 'center'
  }
};

const LoadingDialog = ({ classes }) =>
  <div className={classes.container}>
    <CircularProgress size={40} />
  </div>;

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(withStyles(LoadingDialog, styles));
